import { gql } from '@grandvisionhq/graphql';
import '../fragments/checkout-mutation-result.js';
import '../fragments/cart-mutation-failures.js';
import '../fragments/recreate-ordered-checkout-failure.js';
import { recreateOrderedCheckoutResult } from '../fragments/recreate-ordered-checkout-result.js';
import '../fragments/paypal-payment.js';
import '../fragments/saved-user-details.js';

const RECREATE_ORDERED_CHECKOUT = gql`
  mutation RecreateOrderedCheckout($orderedCheckoutInput: OrderedCheckoutInput!) {
    recreateOrderedCheckout(input: $orderedCheckoutInput) {
      ...RecreateOrderedCheckoutFragment
    }
  }
  ${recreateOrderedCheckoutResult}
`;

export { RECREATE_ORDERED_CHECKOUT };
//# sourceMappingURL=recreate-ordered-checkout.js.map
